<template>
  <div class="kt-portlet kt-portlet--mobile">
    <!--begin::Form-->
    <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
      <div class="kt-portlet__head kt-portlet__head--lg">
        <div class="kt-portlet__head-label">
          <span class="kt-portlet__head-icon">
            <i class="kt-font-brand flaticon-home"></i>
          </span>
          <h3 class="kt-portlet__head-title">
            {{ this.$route.meta.breadcrumb }}
          </h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="kt-section kt-section--first">
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label-required">รหัสร้านค้า (ตัวแทนจำหน่ายย่อย):</label>
                <input
                  id="cssaShopSubAgentCode"
                  name="cssaShopSubAgentCode"
                  v-model="cssaShopSubAgentCode"
                  type="text"
                  maxlength="50"
                  class="form-control"
                  placeholder="รหัสร้านค้า (ตัวแทนจำหน่ายย่อย)"
                />
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label-required">ชื่อร้านค้า (ตัวแทนจำหน่ายย่อย):</label>
                <input
                  id="cssaShopSubAgentName"
                  name="cssaShopSubAgentName"
                  v-model="cssaShopSubAgentName"
                  type="text"
                  maxlength="256"
                  class="form-control"
                  placeholder="ชื่อร้านค้า (ตัวแทนจำหน่ายย่อย)"
                />
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label-required"
                  >ชื่อร้านค้า 2 (ตัวแทนจำหน่ายย่อย):</label
                >
                <input
                  id="cssaShopSubAgentName2"
                  name="cssaShopSubAgentName2"
                  v-model="cssaShopSubAgentName2"
                  type="text"
                  maxlength="256"
                  class="form-control"
                  placeholder="ชื่อร้านค้า 2 (ตัวแทนจำหน่ายย่อย)"
                />
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label>ประเภทร้านค้า:</label>
                <select2
                  :class="'form-control m-select2'"
                  :style="'width: 100%;'"
                  :id="'cssaShopType'"
                  :name="'cssaShopType'"
                  :select2-options="cssaShopTypeOptions"
                  v-model="cssaShopType"
                  ref="cssaShopTypeSelect2"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>

            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label-required">ประเภทการล้างเครื่อง:</label>
                <select2
                  :class="'form-control m-select2'"
                  :style="'width: 100%;'"
                  :id="'cssaShopPMType'"
                  :name="'cssaShopPMType'"
                  :select2-options="cssaShopPMTypeOptions"
                  v-model="cssaShopPMType"
                  ref="cssaShopPMTypeSelect2"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>

            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label-required">สถานะประเภทร้านค้า:</label>
                <select2
                  :class="'form-control m-select2'"
                  :style="'width: 100%;'"
                  :id="'cshShopGroup'"
                  :name="'cshShopGroup'"
                  :select2-options="cshShopGroupOptions"
                  v-model="cshShopGroup"
                  ref="cshShopGroupSelect2"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>

            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label>ที่อยู่:</label>
                <input
                  id="cssaAddress"
                  name="cssaAddress"
                  v-model="cssaAddress"
                  type="text"
                  maxlength="256"
                  class="form-control"
                  placeholder="ที่อยู่"
                />
              </div>
            </div>
            
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label>จังหวัด:</label>
                <select2
                  :class="'form-control m-select2'"
                  :style="'width: 100%;'"
                  :id="'cssaProvinceId'"
                  :name="'cssaProvinceId'"
                  :select2-options="cssaProvinceIdOptions"
                  v-model="cssaProvinceId"
                  ref="cssaProvinceIdSelect2"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label>อำเภอ:</label>
                <select2
                  :class="'form-control m-select2'"
                  :style="'width: 100%;'"
                  :id="'cssaAmphurId'"
                  :name="'cssaAmphurId'"
                  :select2-options="cssaAmphurIdOptions"
                  v-model="cssaAmphurId"
                  ref="cssaAmphurIdSelect2"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label>ตำบล:</label>
                <select2
                  :class="'form-control m-select2'"
                  :style="'width: 100%;'"
                  :id="'cssaTumbolId'"
                  :name="'cssaTumbolId'"
                  :select2-options="cssaTumbolIdOptions"
                  v-model="cssaTumbolId"
                  ref="cssaTumbolIdSelect2"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-12col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label">ชื่อ-สกุลผู้ติดต่อ:</label>
                <input
                  id="cssaContactFullName"
                  name="cssaContactFullName"
                  v-model="cssaContactFullName"
                  type="text"
                  maxlength="256"
                  class="form-control"
                  placeholder="ชื่อ-สกุลผู้ติดต่อ"
                />
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label">อีเมล:</label>
                <input
                  id="cssaEmail"
                  name="cssaEmail"
                  v-model="cssaEmail"
                  type="text"
                  maxlength="256"
                  class="form-control"
                  placeholder="อีเมล"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label>เบอร์โทร:</label>
                <input
                  id="cssaTel"
                  name="cssaTel"
                  v-model="cssaTel"
                  type="text"
                  maxlength="256"
                  class="form-control"
                  placeholder="เบอร์โทร"
                />
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label-required">ผู้ดูแลร้านค้าตัวแทนจำหน่ายย่อย:</label>
                <select2
                  :class="'form-control m-select2'"
                  :style="'width: 100%;'"
                  :id="'cssaShopCode'"
                  :name="'cssaShopCode'"
                  :select2-options="cssaShopCodeOptions"
                  v-model="cssaShopCode"
                  ref="cssaShopCodeSelect2"
                  @selectChange="onShopCodeChange"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label">ชื่อเจ้าหน้าที่ดูแล (ร้านค้า):</label>
                <input
                  id="cssaContactShopName"
                  name="cssaContactShopName"
                  v-model="cssaContactShopName"
                  type="text"
                  maxlength="256"
                  class="form-control"
                  placeholder="ชื่อเจ้าหน้าที่ดูแล (ร้านค้า)"
                />
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label">นามสกุลเจ้าหน้าที่ดูแล (ร้านค้า):</label>
                <input
                  id="cssaContactShopLName"
                  name="cssaContactShopLName"
                  v-model="cssaContactShopLName"
                  type="text"
                  maxlength="256"
                  class="form-control"
                  placeholder="นามสกุลเจ้าหน้าที่ดูแล (ร้านค้า)"
                />
              </div>
            </div>
            <div class="col-xl-6" v-if="$root.canShow('super_admin')">
              <div class="form-group">
                <label class="label">เจ้าหน้าที่ดูแล (Boonrawd)</label>
                <select2
                  :class="'form-control m-select2'"
                  :style="'width: 100%;'"
                  :id="'cssaEmpId'"
                  :name="'cssaEmpId'"
                  :select2-options="cssaEmpIdOptions"
                  v-model="cssaEmpId"
                  ref="cssaEmpIdSelect2"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
          </div>
          <!-- Begin: CR-PM-2026 Req 2 — ตั้งค่าระยะ Check-In/Check-Out -->
          <div class="row">
            <div class="col-xl-12">
              <div class="form-group">
                <label class="label-required">ตั้งค่าระยะ Check-In/Check-Out:</label>
                <div>
                  <label class="kt-radio kt-radio--bold kt-radio--brand" style="margin-right: 30px;">
                    <input type="radio" v-model="useSettingCheckinRange" :value="true" /> กำหนดตามตั้งค่าพื้นฐาน
                    <span></span>
                  </label>
                  <label class="kt-radio kt-radio--bold kt-radio--brand">
                    <input type="radio" v-model="useSettingCheckinRange" :value="false" /> กำหนดเอง
                    <span></span>
                  </label>
                  <button v-if="!useSettingCheckinRange" type="button" class="btn btn-sm btn-clean btn-icon"
                    @click="resetCheckinRange" title="ใช้ค่า default">
                    <i class="la la-times"></i>
                  </button>
                </div>
                <div v-if="!useSettingCheckinRange" class="mt-2" style="max-width: 300px;">
                  <label class="label-required">ระยะ (เมตร):</label>
                  <input type="number" min="1" max="10000" v-model.number="customCheckInRange"
                    class="form-control" placeholder="ระบุระยะ (เมตร)" name="customCheckInRange"
                    @input="checkCustomCheckInRangeMax" @change="checkCustomCheckInRangeMax" />
                  <span v-if="customCheckInRangeMaxError" class="text-danger small">{{ customCheckInRangeMaxError }}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- End: CR-PM-2026 Req 2 -->

          <!-- Begin:Map element -->
          <div class="row">
            <div class="col-xl-12">
              <div class="form-group">
                <label>ตำแหน่งที่ตั้ง:</label>
                <div v-if="cshLat === null">
                  <button
                    type="button"
                    class="btn m-btn--pill btn-info btn-block col-xl-2"
                    @click="getMap"
                  >
                    ระบุข้อมูลตำแหน่งที่ตั้ง
                  </button>
                </div>
                <div v-else>
                  <GmapMap
                    :center="{ lat: cshLat, lng: cshLng }"
                    :zoom="15"
                    :clickable="true"
                    @click="updateCoordinates"
                    style="width: 500px; height: 300px"
                  >
                    <gmap-marker
                      :key="index"
                      v-for="(m, index) in markers"
                      :position="m.position"
                      :draggable="true"
                      @drag="updateCoordinates"
                      :clickable="true"
                      @click="updateCoordinates"
                    ></gmap-marker>
                  </GmapMap>
                  <br />
                  <div>
                    <button
                      type="button"
                      class="btn btn-sm btn-secondary"
                      @click="openMap()"
                    >
                      <i class="far fa-map"></i> Open GoogleMaps
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- End:Map element -->

          <!-- Begin:Picture element (GCS Upload) -->
          <div class="row">
            <div class="col-xl-12">
              <div class="form-group">
                <label
                  >รูปภาพ:<span
                    class="text-sm text-danger"
                    style="font-size:small"
                  >
                    (เลือกได้เฉพาะสกุลไฟล์ JPG,JPEG,PNG ขนาดไม่เกิน 10Mb.)</span
                  ></label
                >
                <button
                  type="button"
                  class="btn m-btn--pill btn-info btn-block uploader-btn col-xl-2"
                  @click="uploadFile"
                >
                  <i class="flaticon-upload-1"></i>รูป
                </button>
                <div class="row" id="container-img">
                  <div
                    v-for="(image, index) in FileUpload"
                    :key="index"
                    class="col-md-4 m--margin-top-20 img-wrap"
                  >
                    <img
                      v-if="image.isLoaded !== false"
                      :src="image.urlImg"
                      class="img-plant img-thumbnail card-img-top"
                      @error="handleImageError(image)"
                      @load="handleImageLoad(image)"
                    />
                    <div v-else class="img-placeholder">ไม่สามารถโหลดรูปภาพได้</div>
                    <a
                      href="javascript:;"
                      style="position:absolute;top:10px;right:20px;"
                      class="btn m-btn--pill btn-danger m-btn close"
                      @click="removeImage(image.pictureId)"
                    >
                      <span class="m--font-inverse-danger la la-trash"></span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- End:Picture element -->

          <!-- Begin:InActiveStatus element -->
          <div class="row">
            <div class="col-xl-12">
              <div class="form-group">
                <label>สถานะ:</label>
                <div class="form-check">
                  <label class="form-check-label kt-checkbox">
                    <input
                      id="cssaInActiveStatus"
                      name="cssaInActiveStatus"
                      v-model="cssaInActiveStatus"
                      type="checkbox"
                      class="form-check-input"
                    />
                    เปิดใช้งาน
                    <span></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <!-- End:InActiveStatus element -->

          <div v-if="this.$root.canShow([''])" class="col-xl-12">
              <div class="form-group">
                <label>[PM] ตั้งค่าใช้ PM (รูปแบบพิเศษ)</label>
                <div class="form-check">
                  <label class="form-check-label kt-checkbox">
                    <input
                      id="cShIsSpecialPM"
                      name="cShIsSpecialPM"
                      v-model="cShIsSpecialPM"
                      type="checkbox"
                      class="form-check-input"
                    />
                    เปิดใช้งาน PM (รูปแบบพิเศษ)
                    <span></span>
                  </label>
                </div>
               </div>
              </div>


        </div>
      </div>
      <div class="kt-portlet__foot">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="$router.go(-1)"
        >
          <i class="la la-close"></i> ย้อนกลับ
        </button>
        <button type="submit" class="btn btn-primary">
          <i class="la la-save"></i> บันทึกข้อมูล
        </button>
      </div>
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import axios from "axios";
import select2 from "../../../Shared/Select2";
import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCeGao-PkONmiyVksl46W_OUHt854bcrqE",
    libraries: "places",

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },
});

export default {
  components: {
    select2,
  },
  name: "GoogleMap",
  data: function() {
    var self = this;

    return {
      cssaShopSubAgentCode: null,
      cshCustomerCode: null,
      cssaShopSubAgentName: null,
      cssaShopSubAgentName2: null,
      cssaShopType: null,
      cssaShopPMType : null,
      cshShopGroup: null,
      cssaAddress: null,
      cssaProvinceId: null,
      cssaAmphurId: null,
      cssaTumbolId: null,
      cshSubAgent: false,
      cssaContactFullName: null,
      cssaEmail: null,
      cssaTel: null,
      cssaShopCode: null,
      cssaContactShopName: null,
      cssaContactShopLName: null,
      cssaEmpId: null,
      cssaInActiveStatus: true,
      cShIsSpecialPM : false,
      cshLat: null,
      cshLng: null,
      // CR-PM-2026 Req 2 — per-subagent-shop radius config (default = use Setting)
      useSettingCheckinRange: true,
      customCheckInRange: null,
      customCheckInRangeMaxError: null,
      markers: [],
      FileUpload: [],
      cssaShopTypeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ShopType/Select2SearchShopType",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      cssaShopPMTypeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Variables/Select2MasterShopTypePM",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      cshShopGroupOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ShopType/Select2SearchShopGroup",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      cssaEmpIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Employee/Select2Employee",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      cssaProvinceIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchProvince",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      cssaAmphurIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchAmpher",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              provinceId: self.cssaProvinceId,
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      cssaTumbolIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchTumbol",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              ampherId: self.cssaAmphurId,
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      cssaShopCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Shop/ShopOption",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              department: [],
              province_id: [],
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  methods: {
    // CR-PM-2026 Req 2 — reset to default (use Setting)
    resetCheckinRange() {
        this.useSettingCheckinRange = true;
        this.customCheckInRange = null;
        this.customCheckInRangeMaxError = null;
    },
    checkCustomCheckInRangeMax(e) {
      const raw = e.target.value;
      const val = Number(raw);
      if (raw !== "" && !isNaN(val) && val > 10000) {
        this.customCheckInRangeMaxError = "ไม่สามารถกำหนดระยะทางเกิน 10,000 เมตร ได้";
        // Clamp value back to 10000 (block typing beyond)
        this.customCheckInRange = 10000;
        this.$nextTick(() => { if (e.target) e.target.value = 10000; });
      } else {
        this.customCheckInRangeMaxError = null;
      }
    },
    async formSubmit(e) {
      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      let router = this.$router;
      let self = this;

      try {
        // Upload new files to GCS
        let uploadedFiles = [];
        for (let file of this.FileUpload) {
          if (file.isNew && file.fileDataContext) {
            const formData = new FormData();
            formData.append("File", file.fileDataContext);
            formData.append("IsMaster", true);
            formData.append("FolderName", "MasterShopSubAgent");

            const uploadResponse = await axios.post("/Api/File/FileUpload", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            });

            if (uploadResponse.data && uploadResponse.data.fileInfoId) {
              uploadedFiles.push({
                fileInfoId: uploadResponse.data.fileInfoId,
                fileName: uploadResponse.data.fileInfoId,
                downloadUrl: uploadResponse.data.fileUrl,
              });
            }
          }
        }

        // Prepare pictures data for API
        let picturesData = uploadedFiles.map((pic) => ({
          fileInfoId: pic.fileInfoId,
          fileName: pic.fileName,
          downloadUrl: pic.downloadUrl,
        }));

        const response = await axios.post("/Api/SubAgent", {
          SubAgentCode: this.cssaShopSubAgentCode,
          ShopSubAgentName: this.cssaShopSubAgentName,
          ShopSubAgentName2: this.cssaShopSubAgentName2,
          ShopTypeId: this.cssaShopType,
          ShopPMType: this.cssaShopPMType,
          ShopGroupId: this.cshShopGroup,
          Address: this.cssaAddress,
          ProvinceId: this.cssaProvinceId,
          AmphurId: this.cssaAmphurId,
          TumbolId: this.cssaTumbolId,
          ContactFullName: this.cssaContactFullName,
          Email: this.cssaEmail,
          Tel: this.cssaTel,
          ShopCode: this.cssaShopCode,
          Latitude: this.cshLat,
          Longitude: this.cshLng,
          ContactShopName: this.cssaContactShopName,
          ContactShopLastName: this.cssaContactShopLName,
          EmployeeId: this.cssaEmpId,
          SubAgentPictures: picturesData,
          InActiveStatus: !this.cssaInActiveStatus,
          IsSpecialPM: this.cShIsSpecialPM,
          // CR-PM-2026 Req 2 — radius
          UseSettingCheckinRange: this.useSettingCheckinRange,
          CheckInRange: this.useSettingCheckinRange ? null : this.customCheckInRange,
        });

        if (response.data.status) {
          KTApp.unblockPage();
          Swal.fire("สำเร็จ", response.data.message, "success").then(function() {
            router.go(-1);
            self.$parent.reloadDataTable(false);
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
        }
      } catch (error) {
        var errorMsg = (error.response && error.response.data && error.response.data.message) ? error.response.data.message : error.message;
        Swal.fire("เกิดข้อผิดพลาด", errorMsg, "error");
      } finally {
        KTApp.unblockPage();
      }
    },
    getMap: function() {
      //get current lat,lon by IP
      navigator.geolocation.getCurrentPosition((position) => {
        this.cshLat = position.coords.latitude;
        this.cshLng = position.coords.longitude;
        this.markers = [
          {
            position: { lat: this.cshLat, lng: this.cshLng },
            animation: google.maps.Animation.DROP,
          },
        ];
      });
    },
    //get current lat,lng (dragable)
    updateCoordinates(location) {
      this.cshLat = location.latLng.lat();
      this.cshLng = location.latLng.lng();
      map: this.map;
      this.markers = [{ position: { lat: this.cshLat, lng: this.cshLng } }];
    },
    uploadFile() {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "image/jpeg,image/png,image/jpg";
      input.click();
      input.addEventListener("change", (event) => {
        const file = event.target.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onload = (e) => {
            const newImage = {
              pictureId: `new_${Date.now()}`,
              urlImg: e.target.result,
              fileName: file.name,
              isNew: true,
              fileDataContext: file,
              isLoaded: true,
            };
            this.FileUpload.push(newImage);
          };
          reader.readAsDataURL(file);
        }
      });
    },
    removeImage(pictureId) {
      Swal.fire({
        title: "ยืนยันคำสั่ง",
        text: "คุณต้องการลบรูปภาพนี้หรือไม่",
        icon: "warning",
        confirmButtonText: "<span><i class='la la-check'></i><span>ฉันต้องการลบรูปภาพนี้</span></span>",
        confirmButtonClass: "btn btn-danger m-btn m-btn--pill m-btn--icon",
        showCancelButton: true,
        cancelButtonText: "<span><i class='la la-close'></i><span>ยกเลิก</span></span>",
        cancelButtonClass: "btn btn-secondary m-btn m-btn--pill m-btn--icon",
      }).then((result) => {
        if (result.value) {
          this.FileUpload = this.FileUpload.filter((img) => img.pictureId !== pictureId);
          Swal.fire("เรียบร้อย!", "ลบรูปภาพเรียบร้อย", "success");
        }
      });
    },
    handleImageError(image) {
      image.isLoaded = false;
    },
    handleImageLoad(image) {
      image.isLoaded = true;
    },
    onShopCodeChange(id, text, data, ref) {
      let router = this.$router;
      let self = this;

      console.log(text);
      if (text != (null || "")) {
        self.cssaContactShopName = data[0].data.firstName;
        self.cssaContactShopLName = data[0].data.lastName;
      } else {
        self.cssaContactShopName = null;
        self.cssaContactShopLName = null;
      }
    },
    openMap() {
      var self = this;
      window.open(
        "https://www.google.com/maps/search/?api=1&query=" +
          self.cshLat +
          "," +
          self.cshLng,
        "_blank"
      );
    },
  },
  async mounted() {
    let self = this;
    let router = this.$router;

    // set validation rules
    $(this.$refs.form).validate({
      rules: {
        cssaShopSubAgentName: "required",
        cssaShopSubAgentCode: "required",
        cssaShopSubAgentName2: "required",
        cssaShopCode: "required",
        cshShopGroup: "required",
        cssaShopPMType : "required",
        // CR-PM-2026 Issue 14: required เฉพาะกรณี "กำหนดเอง" (useSettingCheckinRange=false)
        customCheckInRange: {
          required: function() { return !self.useSettingCheckinRange; }
        },
      },
      messages: {
        cssaShopSubAgentCode: "กรุณากรอกรหัสร้านร้านค้า (ตัวแทนจำหน่ายย่อย)",
        cssaShopSubAgentName: "กรุณากรอกชื่อร้านค้า (ตัวแทนจำหน่ายย่อย)",
        cssaShopSubAgentName2: "กรุณากรอกชื่อร้านค้า 2 (ตัวแทนจำหน่ายย่อย)",
        cssaShopCode: "กรุณาเลือกผู้ดูแลร้านค้าตัวแทนจำหน่ายย่อย",
        cshShopGroup: "กรุณาเลือกสถานะประเภทร้านค้า",
        cssaShopPMType : "ประเภทการล้างเครื่อง",
        customCheckInRange: "กรุณาระบุระยะ (เมตร)",
      },
    });
  },
};
</script>

<style lang="scss">
#myProgress {
  width: 100%;
  background-color: #ddd;
}

.myBar {
  width: 10%;
  height: 30px;
  background-color: #4caf50;
  text-align: center;
  line-height: 30px;
  color: white;
}

.btm-reload-img-plant {
  position: absolute;
  top: 5px;
  right: 20px;
}
.btm-delete-img-plant {
  position: absolute;
  top: 5px;
  right: 70px;
}
.btm-remove-img-plant {
  position: absolute;
  top: 5px;
  right: 20px;
}

.select2,
.select2-dropdown {
  font-size: 1rem;
}

@media (max-width: 425px) {
  .m-body .m-content {
    padding: 20px 5px;
  }
}

@media (max-width: 1200px) {
  .m-wizard.m-wizard--2 {
    margin-top: 8rem !important;
  }

  #activity_wizard .m-wizard__form .m-form .m-portlet__body {
    padding: 2.2rem 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// App/Components/Master/ShopSupAgent/CreateShopSubAgent.vue